/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as EmailConfirmationRouteImport } from './routes/email-confirmation'
import { Route as EntrypointRouteImport } from './routes/entrypoint'
import { Route as AccommodationDetailsIndexRouteImport } from './routes/accommodation-details/index'
import { Route as AdminFeedbackIndexRouteImport } from './routes/admin-feedback/index'
import { Route as AllExcursionsIndexRouteImport } from './routes/all-excursions/index'
import { Route as AuthIndexRouteImport } from './routes/auth/index'
import { Route as AuthRegisterRouteImport } from './routes/auth/register'
import { Route as AuthVerifyRouteImport } from './routes/auth/verify'
import { Route as AuthVkCallbackRouteImport } from './routes/auth/vk-callback'
import { Route as AuthVkEmailRouteImport } from './routes/auth/vk-email'
import { Route as AuthVkSuccessRouteImport } from './routes/auth/vk-success'
import { Route as AuthVkVerifyRouteImport } from './routes/auth/vk-verify'
import { Route as AvailableAccommodationsIndexRouteImport } from './routes/available-accommodations/index'
import { Route as CheckPlannerIndexRouteImport } from './routes/check-planner/index'
import { Route as ErrorPaymentErrorRouteImport } from './routes/error/payment-error'
import { Route as ExcursionSelectionIndexRouteImport } from './routes/excursion-selection/index'
import { Route as ExcursionIndexRouteImport } from './routes/excursion/index'
import { Route as ExternalFeedbackIndexRouteImport } from './routes/external-feedback/index'
import { Route as FeedbackIndexRouteImport } from './routes/feedback/index'
import { Route as FinalOrderIndexRouteImport } from './routes/final-order/index'
import { Route as OrderIndexRouteImport } from './routes/order/index'
import { Route as PreorderIndexRouteImport } from './routes/preorder/index'
import { Route as ProfileIndexRouteImport } from './routes/profile/index'
import { Route as ProfileAuthorRouteImport } from './routes/profile/author'
import { Route as ProfileChangeEmailRouteImport } from './routes/profile/change-email'
import { Route as ProfileCreateScenarioRouteImport } from './routes/profile/create-scenario'
import { Route as ProfileEditRouteImport } from './routes/profile/edit'
import { Route as ProfileOrdersRouteImport } from './routes/profile/orders'
import { Route as ProfileScenariosRouteImport } from './routes/profile/scenarios'
import { Route as ProfileVerifyEmailRouteImport } from './routes/profile/verify-email'
import { Route as ScenarioScenarioSlugRouteImport } from './routes/scenario/$scenarioSlug'
import { Route as TourTourIdRouteImport } from './routes/tour/$tourId'
import { Route as TripPlannerIndexRouteImport } from './routes/trip-planner/index'
import { Route as UserFormIndexRouteImport } from './routes/user-form/index'
import { Route as UserFormConfirmationRouteImport } from './routes/user-form/confirmation'
import { Route as UserFormGuestDetailsRouteImport } from './routes/user-form/guest-details'
import { Route as UserFormSelfDetailsRouteImport } from './routes/user-form/self-details'
import { Route as BookingCancellationIndexRouteImport } from './routes/booking/cancellation/index'
import { Route as BookingCancellationOrderNumberRouteImport } from './routes/booking/cancellation/$orderNumber'
import { Route as BookingCancellationSuccessRouteImport } from './routes/booking/cancellation/success'
import { Route as UserFormErrorsAlreadyBookedErrorRouteImport } from './routes/user-form/errors/already-booked-error'

const AdminFeedbackBrokenLinkLazyRouteImport = createFileRoute(
  '/admin-feedback/broken-link',
)()
const AdminFeedbackThanksLazyRouteImport = createFileRoute(
  '/admin-feedback/thanks',
)()
const DocsIndexLazyRouteImport = createFileRoute('/docs/')()
const ErrorBadRequestLazyRouteImport = createFileRoute('/error/bad-request')()
const ErrorInternalErrorLazyRouteImport = createFileRoute(
  '/error/internal-error',
)()
const FeedbackAlreadySubmittedLazyRouteImport = createFileRoute(
  '/feedback/already-submitted',
)()
const FeedbackBrokenLinkLazyRouteImport = createFileRoute(
  '/feedback/broken-link',
)()
const FeedbackThanksLazyRouteImport = createFileRoute('/feedback/thanks')()
const PrivacyPolicyIndexLazyRouteImport = createFileRoute('/privacy-policy/')()
const TermsAndConditionsIndexLazyRouteImport = createFileRoute(
  '/terms-and-conditions/',
)()

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailConfirmationRoute = EmailConfirmationRouteImport.update({
  id: '/email-confirmation',
  path: '/email-confirmation',
  getParentRoute: () => rootRouteImport,
} as any)
const EntrypointRoute = EntrypointRouteImport.update({
  id: '/entrypoint',
  path: '/entrypoint',
  getParentRoute: () => rootRouteImport,
} as any)
const AccommodationDetailsIndexRoute =
  AccommodationDetailsIndexRouteImport.update({
    id: '/accommodation-details/',
    path: '/accommodation-details/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminFeedbackIndexRoute = AdminFeedbackIndexRouteImport.update({
  id: '/admin-feedback/',
  path: '/admin-feedback/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminFeedbackBrokenLinkLazyRoute =
  AdminFeedbackBrokenLinkLazyRouteImport.update({
    id: '/admin-feedback/broken-link',
    path: '/admin-feedback/broken-link',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/admin-feedback/broken-link.lazy').then((d) => d.Route),
  )
const AdminFeedbackThanksLazyRoute = AdminFeedbackThanksLazyRouteImport.update({
  id: '/admin-feedback/thanks',
  path: '/admin-feedback/thanks',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/admin-feedback/thanks.lazy').then((d) => d.Route),
)
const AllExcursionsIndexRoute = AllExcursionsIndexRouteImport.update({
  id: '/all-excursions/',
  path: '/all-excursions/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVerifyRoute = AuthVerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVkCallbackRoute = AuthVkCallbackRouteImport.update({
  id: '/vk-callback',
  path: '/vk-callback',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVkEmailRoute = AuthVkEmailRouteImport.update({
  id: '/vk-email',
  path: '/vk-email',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVkSuccessRoute = AuthVkSuccessRouteImport.update({
  id: '/vk-success',
  path: '/vk-success',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVkVerifyRoute = AuthVkVerifyRouteImport.update({
  id: '/vk-verify',
  path: '/vk-verify',
  getParentRoute: () => AuthRoute,
} as any)
const AvailableAccommodationsIndexRoute =
  AvailableAccommodationsIndexRouteImport.update({
    id: '/available-accommodations/',
    path: '/available-accommodations/',
    getParentRoute: () => rootRouteImport,
  } as any)
const CheckPlannerIndexRoute = CheckPlannerIndexRouteImport.update({
  id: '/check-planner/',
  path: '/check-planner/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsIndexLazyRoute = DocsIndexLazyRouteImport.update({
  id: '/docs/',
  path: '/docs/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/docs/index.lazy').then((d) => d.Route))
const ErrorBadRequestLazyRoute = ErrorBadRequestLazyRouteImport.update({
  id: '/error/bad-request',
  path: '/error/bad-request',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/error/bad-request.lazy').then((d) => d.Route),
)
const ErrorInternalErrorLazyRoute = ErrorInternalErrorLazyRouteImport.update({
  id: '/error/internal-error',
  path: '/error/internal-error',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/error/internal-error.lazy').then((d) => d.Route),
)
const ErrorPaymentErrorRoute = ErrorPaymentErrorRouteImport.update({
  id: '/error/payment-error',
  path: '/error/payment-error',
  getParentRoute: () => rootRouteImport,
} as any)
const ExcursionSelectionIndexRoute = ExcursionSelectionIndexRouteImport.update({
  id: '/excursion-selection/',
  path: '/excursion-selection/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExcursionIndexRoute = ExcursionIndexRouteImport.update({
  id: '/excursion/',
  path: '/excursion/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExternalFeedbackIndexRoute = ExternalFeedbackIndexRouteImport.update({
  id: '/external-feedback/',
  path: '/external-feedback/',
  getParentRoute: () => rootRouteImport,
} as any)
const FeedbackIndexRoute = FeedbackIndexRouteImport.update({
  id: '/feedback/',
  path: '/feedback/',
  getParentRoute: () => rootRouteImport,
} as any)
const FeedbackAlreadySubmittedLazyRoute =
  FeedbackAlreadySubmittedLazyRouteImport.update({
    id: '/feedback/already-submitted',
    path: '/feedback/already-submitted',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/feedback/already-submitted.lazy').then((d) => d.Route),
  )
const FeedbackBrokenLinkLazyRoute = FeedbackBrokenLinkLazyRouteImport.update({
  id: '/feedback/broken-link',
  path: '/feedback/broken-link',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/feedback/broken-link.lazy').then((d) => d.Route),
)
const FeedbackThanksLazyRoute = FeedbackThanksLazyRouteImport.update({
  id: '/feedback/thanks',
  path: '/feedback/thanks',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/feedback/thanks.lazy').then((d) => d.Route),
)
const FinalOrderIndexRoute = FinalOrderIndexRouteImport.update({
  id: '/final-order/',
  path: '/final-order/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrderIndexRoute = OrderIndexRouteImport.update({
  id: '/order/',
  path: '/order/',
  getParentRoute: () => rootRouteImport,
} as any)
const PreorderIndexRoute = PreorderIndexRouteImport.update({
  id: '/preorder/',
  path: '/preorder/',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyIndexLazyRoute = PrivacyPolicyIndexLazyRouteImport.update({
  id: '/privacy-policy/',
  path: '/privacy-policy/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/privacy-policy/index.lazy').then((d) => d.Route),
)
const ProfileIndexRoute = ProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileAuthorRoute = ProfileAuthorRouteImport.update({
  id: '/profile/author',
  path: '/profile/author',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileChangeEmailRoute = ProfileChangeEmailRouteImport.update({
  id: '/profile/change-email',
  path: '/profile/change-email',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileCreateScenarioRoute = ProfileCreateScenarioRouteImport.update({
  id: '/profile/create-scenario',
  path: '/profile/create-scenario',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileEditRoute = ProfileEditRouteImport.update({
  id: '/profile/edit',
  path: '/profile/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileOrdersRoute = ProfileOrdersRouteImport.update({
  id: '/profile/orders',
  path: '/profile/orders',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileScenariosRoute = ProfileScenariosRouteImport.update({
  id: '/profile/scenarios',
  path: '/profile/scenarios',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileVerifyEmailRoute = ProfileVerifyEmailRouteImport.update({
  id: '/profile/verify-email',
  path: '/profile/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const ScenarioScenarioSlugRoute = ScenarioScenarioSlugRouteImport.update({
  id: '/scenario/$scenarioSlug',
  path: '/scenario/$scenarioSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsAndConditionsIndexLazyRoute =
  TermsAndConditionsIndexLazyRouteImport.update({
    id: '/terms-and-conditions/',
    path: '/terms-and-conditions/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/terms-and-conditions/index.lazy').then((d) => d.Route),
  )
const TourTourIdRoute = TourTourIdRouteImport.update({
  id: '/tour/$tourId',
  path: '/tour/$tourId',
  getParentRoute: () => rootRouteImport,
} as any)
const TripPlannerIndexRoute = TripPlannerIndexRouteImport.update({
  id: '/trip-planner/',
  path: '/trip-planner/',
  getParentRoute: () => rootRouteImport,
} as any)
const UserFormIndexRoute = UserFormIndexRouteImport.update({
  id: '/user-form/',
  path: '/user-form/',
  getParentRoute: () => rootRouteImport,
} as any)
const UserFormConfirmationRoute = UserFormConfirmationRouteImport.update({
  id: '/user-form/confirmation',
  path: '/user-form/confirmation',
  getParentRoute: () => rootRouteImport,
} as any)
const UserFormGuestDetailsRoute = UserFormGuestDetailsRouteImport.update({
  id: '/user-form/guest-details',
  path: '/user-form/guest-details',
  getParentRoute: () => rootRouteImport,
} as any)
const UserFormSelfDetailsRoute = UserFormSelfDetailsRouteImport.update({
  id: '/user-form/self-details',
  path: '/user-form/self-details',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingCancellationIndexRoute =
  BookingCancellationIndexRouteImport.update({
    id: '/booking/cancellation/',
    path: '/booking/cancellation/',
    getParentRoute: () => rootRouteImport,
  } as any)
const BookingCancellationOrderNumberRoute =
  BookingCancellationOrderNumberRouteImport.update({
    id: '/booking/cancellation/$orderNumber',
    path: '/booking/cancellation/$orderNumber',
    getParentRoute: () => rootRouteImport,
  } as any)
const BookingCancellationSuccessRoute =
  BookingCancellationSuccessRouteImport.update({
    id: '/booking/cancellation/success',
    path: '/booking/cancellation/success',
    getParentRoute: () => rootRouteImport,
  } as any)
const UserFormErrorsAlreadyBookedErrorRoute =
  UserFormErrorsAlreadyBookedErrorRouteImport.update({
    id: '/user-form/errors/already-booked-error',
    path: '/user-form/errors/already-booked-error',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteWithChildren
  '/email-confirmation': typeof EmailConfirmationRoute
  '/entrypoint': typeof EntrypointRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/auth/vk-callback': typeof AuthVkCallbackRoute
  '/auth/vk-email': typeof AuthVkEmailRoute
  '/auth/vk-success': typeof AuthVkSuccessRoute
  '/auth/vk-verify': typeof AuthVkVerifyRoute
  '/error/payment-error': typeof ErrorPaymentErrorRoute
  '/profile/author': typeof ProfileAuthorRoute
  '/profile/change-email': typeof ProfileChangeEmailRoute
  '/profile/create-scenario': typeof ProfileCreateScenarioRoute
  '/profile/edit': typeof ProfileEditRoute
  '/profile/orders': typeof ProfileOrdersRoute
  '/profile/scenarios': typeof ProfileScenariosRoute
  '/profile/verify-email': typeof ProfileVerifyEmailRoute
  '/scenario/$scenarioSlug': typeof ScenarioScenarioSlugRoute
  '/tour/$tourId': typeof TourTourIdRoute
  '/user-form/confirmation': typeof UserFormConfirmationRoute
  '/user-form/guest-details': typeof UserFormGuestDetailsRoute
  '/user-form/self-details': typeof UserFormSelfDetailsRoute
  '/admin-feedback/broken-link': typeof AdminFeedbackBrokenLinkLazyRoute
  '/admin-feedback/thanks': typeof AdminFeedbackThanksLazyRoute
  '/error/bad-request': typeof ErrorBadRequestLazyRoute
  '/error/internal-error': typeof ErrorInternalErrorLazyRoute
  '/feedback/already-submitted': typeof FeedbackAlreadySubmittedLazyRoute
  '/feedback/broken-link': typeof FeedbackBrokenLinkLazyRoute
  '/feedback/thanks': typeof FeedbackThanksLazyRoute
  '/accommodation-details/': typeof AccommodationDetailsIndexRoute
  '/admin-feedback/': typeof AdminFeedbackIndexRoute
  '/all-excursions/': typeof AllExcursionsIndexRoute
  '/auth/': typeof AuthIndexRoute
  '/available-accommodations/': typeof AvailableAccommodationsIndexRoute
  '/check-planner/': typeof CheckPlannerIndexRoute
  '/excursion-selection/': typeof ExcursionSelectionIndexRoute
  '/excursion/': typeof ExcursionIndexRoute
  '/external-feedback/': typeof ExternalFeedbackIndexRoute
  '/feedback/': typeof FeedbackIndexRoute
  '/final-order/': typeof FinalOrderIndexRoute
  '/order/': typeof OrderIndexRoute
  '/preorder/': typeof PreorderIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/trip-planner/': typeof TripPlannerIndexRoute
  '/user-form/': typeof UserFormIndexRoute
  '/docs/': typeof DocsIndexLazyRoute
  '/privacy-policy/': typeof PrivacyPolicyIndexLazyRoute
  '/terms-and-conditions/': typeof TermsAndConditionsIndexLazyRoute
  '/booking/cancellation/$orderNumber': typeof BookingCancellationOrderNumberRoute
  '/booking/cancellation/success': typeof BookingCancellationSuccessRoute
  '/user-form/errors/already-booked-error': typeof UserFormErrorsAlreadyBookedErrorRoute
  '/booking/cancellation/': typeof BookingCancellationIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/email-confirmation': typeof EmailConfirmationRoute
  '/entrypoint': typeof EntrypointRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/auth/vk-callback': typeof AuthVkCallbackRoute
  '/auth/vk-email': typeof AuthVkEmailRoute
  '/auth/vk-success': typeof AuthVkSuccessRoute
  '/auth/vk-verify': typeof AuthVkVerifyRoute
  '/error/payment-error': typeof ErrorPaymentErrorRoute
  '/profile/author': typeof ProfileAuthorRoute
  '/profile/change-email': typeof ProfileChangeEmailRoute
  '/profile/create-scenario': typeof ProfileCreateScenarioRoute
  '/profile/edit': typeof ProfileEditRoute
  '/profile/orders': typeof ProfileOrdersRoute
  '/profile/scenarios': typeof ProfileScenariosRoute
  '/profile/verify-email': typeof ProfileVerifyEmailRoute
  '/scenario/$scenarioSlug': typeof ScenarioScenarioSlugRoute
  '/tour/$tourId': typeof TourTourIdRoute
  '/user-form/confirmation': typeof UserFormConfirmationRoute
  '/user-form/guest-details': typeof UserFormGuestDetailsRoute
  '/user-form/self-details': typeof UserFormSelfDetailsRoute
  '/admin-feedback/broken-link': typeof AdminFeedbackBrokenLinkLazyRoute
  '/admin-feedback/thanks': typeof AdminFeedbackThanksLazyRoute
  '/error/bad-request': typeof ErrorBadRequestLazyRoute
  '/error/internal-error': typeof ErrorInternalErrorLazyRoute
  '/feedback/already-submitted': typeof FeedbackAlreadySubmittedLazyRoute
  '/feedback/broken-link': typeof FeedbackBrokenLinkLazyRoute
  '/feedback/thanks': typeof FeedbackThanksLazyRoute
  '/accommodation-details': typeof AccommodationDetailsIndexRoute
  '/admin-feedback': typeof AdminFeedbackIndexRoute
  '/all-excursions': typeof AllExcursionsIndexRoute
  '/auth': typeof AuthIndexRoute
  '/available-accommodations': typeof AvailableAccommodationsIndexRoute
  '/check-planner': typeof CheckPlannerIndexRoute
  '/excursion-selection': typeof ExcursionSelectionIndexRoute
  '/excursion': typeof ExcursionIndexRoute
  '/external-feedback': typeof ExternalFeedbackIndexRoute
  '/feedback': typeof FeedbackIndexRoute
  '/final-order': typeof FinalOrderIndexRoute
  '/order': typeof OrderIndexRoute
  '/preorder': typeof PreorderIndexRoute
  '/profile': typeof ProfileIndexRoute
  '/trip-planner': typeof TripPlannerIndexRoute
  '/user-form': typeof UserFormIndexRoute
  '/docs': typeof DocsIndexLazyRoute
  '/privacy-policy': typeof PrivacyPolicyIndexLazyRoute
  '/terms-and-conditions': typeof TermsAndConditionsIndexLazyRoute
  '/booking/cancellation/$orderNumber': typeof BookingCancellationOrderNumberRoute
  '/booking/cancellation/success': typeof BookingCancellationSuccessRoute
  '/user-form/errors/already-booked-error': typeof UserFormErrorsAlreadyBookedErrorRoute
  '/booking/cancellation': typeof BookingCancellationIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteWithChildren
  '/email-confirmation': typeof EmailConfirmationRoute
  '/entrypoint': typeof EntrypointRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/auth/vk-callback': typeof AuthVkCallbackRoute
  '/auth/vk-email': typeof AuthVkEmailRoute
  '/auth/vk-success': typeof AuthVkSuccessRoute
  '/auth/vk-verify': typeof AuthVkVerifyRoute
  '/error/payment-error': typeof ErrorPaymentErrorRoute
  '/profile/author': typeof ProfileAuthorRoute
  '/profile/change-email': typeof ProfileChangeEmailRoute
  '/profile/create-scenario': typeof ProfileCreateScenarioRoute
  '/profile/edit': typeof ProfileEditRoute
  '/profile/orders': typeof ProfileOrdersRoute
  '/profile/scenarios': typeof ProfileScenariosRoute
  '/profile/verify-email': typeof ProfileVerifyEmailRoute
  '/scenario/$scenarioSlug': typeof ScenarioScenarioSlugRoute
  '/tour/$tourId': typeof TourTourIdRoute
  '/user-form/confirmation': typeof UserFormConfirmationRoute
  '/user-form/guest-details': typeof UserFormGuestDetailsRoute
  '/user-form/self-details': typeof UserFormSelfDetailsRoute
  '/admin-feedback/broken-link': typeof AdminFeedbackBrokenLinkLazyRoute
  '/admin-feedback/thanks': typeof AdminFeedbackThanksLazyRoute
  '/error/bad-request': typeof ErrorBadRequestLazyRoute
  '/error/internal-error': typeof ErrorInternalErrorLazyRoute
  '/feedback/already-submitted': typeof FeedbackAlreadySubmittedLazyRoute
  '/feedback/broken-link': typeof FeedbackBrokenLinkLazyRoute
  '/feedback/thanks': typeof FeedbackThanksLazyRoute
  '/accommodation-details/': typeof AccommodationDetailsIndexRoute
  '/admin-feedback/': typeof AdminFeedbackIndexRoute
  '/all-excursions/': typeof AllExcursionsIndexRoute
  '/auth/': typeof AuthIndexRoute
  '/available-accommodations/': typeof AvailableAccommodationsIndexRoute
  '/check-planner/': typeof CheckPlannerIndexRoute
  '/excursion-selection/': typeof ExcursionSelectionIndexRoute
  '/excursion/': typeof ExcursionIndexRoute
  '/external-feedback/': typeof ExternalFeedbackIndexRoute
  '/feedback/': typeof FeedbackIndexRoute
  '/final-order/': typeof FinalOrderIndexRoute
  '/order/': typeof OrderIndexRoute
  '/preorder/': typeof PreorderIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/trip-planner/': typeof TripPlannerIndexRoute
  '/user-form/': typeof UserFormIndexRoute
  '/docs/': typeof DocsIndexLazyRoute
  '/privacy-policy/': typeof PrivacyPolicyIndexLazyRoute
  '/terms-and-conditions/': typeof TermsAndConditionsIndexLazyRoute
  '/booking/cancellation/$orderNumber': typeof BookingCancellationOrderNumberRoute
  '/booking/cancellation/success': typeof BookingCancellationSuccessRoute
  '/user-form/errors/already-booked-error': typeof UserFormErrorsAlreadyBookedErrorRoute
  '/booking/cancellation/': typeof BookingCancellationIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/email-confirmation'
    | '/entrypoint'
    | '/auth/register'
    | '/auth/verify'
    | '/auth/vk-callback'
    | '/auth/vk-email'
    | '/auth/vk-success'
    | '/auth/vk-verify'
    | '/error/payment-error'
    | '/profile/author'
    | '/profile/change-email'
    | '/profile/create-scenario'
    | '/profile/edit'
    | '/profile/orders'
    | '/profile/scenarios'
    | '/profile/verify-email'
    | '/scenario/$scenarioSlug'
    | '/tour/$tourId'
    | '/user-form/confirmation'
    | '/user-form/guest-details'
    | '/user-form/self-details'
    | '/admin-feedback/broken-link'
    | '/admin-feedback/thanks'
    | '/error/bad-request'
    | '/error/internal-error'
    | '/feedback/already-submitted'
    | '/feedback/broken-link'
    | '/feedback/thanks'
    | '/accommodation-details/'
    | '/admin-feedback/'
    | '/all-excursions/'
    | '/auth/'
    | '/available-accommodations/'
    | '/check-planner/'
    | '/excursion-selection/'
    | '/excursion/'
    | '/external-feedback/'
    | '/feedback/'
    | '/final-order/'
    | '/order/'
    | '/preorder/'
    | '/profile/'
    | '/trip-planner/'
    | '/user-form/'
    | '/docs/'
    | '/privacy-policy/'
    | '/terms-and-conditions/'
    | '/booking/cancellation/$orderNumber'
    | '/booking/cancellation/success'
    | '/user-form/errors/already-booked-error'
    | '/booking/cancellation/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/email-confirmation'
    | '/entrypoint'
    | '/auth/register'
    | '/auth/verify'
    | '/auth/vk-callback'
    | '/auth/vk-email'
    | '/auth/vk-success'
    | '/auth/vk-verify'
    | '/error/payment-error'
    | '/profile/author'
    | '/profile/change-email'
    | '/profile/create-scenario'
    | '/profile/edit'
    | '/profile/orders'
    | '/profile/scenarios'
    | '/profile/verify-email'
    | '/scenario/$scenarioSlug'
    | '/tour/$tourId'
    | '/user-form/confirmation'
    | '/user-form/guest-details'
    | '/user-form/self-details'
    | '/admin-feedback/broken-link'
    | '/admin-feedback/thanks'
    | '/error/bad-request'
    | '/error/internal-error'
    | '/feedback/already-submitted'
    | '/feedback/broken-link'
    | '/feedback/thanks'
    | '/accommodation-details'
    | '/admin-feedback'
    | '/all-excursions'
    | '/auth'
    | '/available-accommodations'
    | '/check-planner'
    | '/excursion-selection'
    | '/excursion'
    | '/external-feedback'
    | '/feedback'
    | '/final-order'
    | '/order'
    | '/preorder'
    | '/profile'
    | '/trip-planner'
    | '/user-form'
    | '/docs'
    | '/privacy-policy'
    | '/terms-and-conditions'
    | '/booking/cancellation/$orderNumber'
    | '/booking/cancellation/success'
    | '/user-form/errors/already-booked-error'
    | '/booking/cancellation'
  id:
    | '__root__'
    | '/'
    | '/auth'
    | '/email-confirmation'
    | '/entrypoint'
    | '/auth/register'
    | '/auth/verify'
    | '/auth/vk-callback'
    | '/auth/vk-email'
    | '/auth/vk-success'
    | '/auth/vk-verify'
    | '/error/payment-error'
    | '/profile/author'
    | '/profile/change-email'
    | '/profile/create-scenario'
    | '/profile/edit'
    | '/profile/orders'
    | '/profile/scenarios'
    | '/profile/verify-email'
    | '/scenario/$scenarioSlug'
    | '/tour/$tourId'
    | '/user-form/confirmation'
    | '/user-form/guest-details'
    | '/user-form/self-details'
    | '/admin-feedback/broken-link'
    | '/admin-feedback/thanks'
    | '/error/bad-request'
    | '/error/internal-error'
    | '/feedback/already-submitted'
    | '/feedback/broken-link'
    | '/feedback/thanks'
    | '/accommodation-details/'
    | '/admin-feedback/'
    | '/all-excursions/'
    | '/auth/'
    | '/available-accommodations/'
    | '/check-planner/'
    | '/excursion-selection/'
    | '/excursion/'
    | '/external-feedback/'
    | '/feedback/'
    | '/final-order/'
    | '/order/'
    | '/preorder/'
    | '/profile/'
    | '/trip-planner/'
    | '/user-form/'
    | '/docs/'
    | '/privacy-policy/'
    | '/terms-and-conditions/'
    | '/booking/cancellation/$orderNumber'
    | '/booking/cancellation/success'
    | '/user-form/errors/already-booked-error'
    | '/booking/cancellation/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  EmailConfirmationRoute: typeof EmailConfirmationRoute
  EntrypointRoute: typeof EntrypointRoute
  ErrorPaymentErrorRoute: typeof ErrorPaymentErrorRoute
  ProfileAuthorRoute: typeof ProfileAuthorRoute
  ProfileChangeEmailRoute: typeof ProfileChangeEmailRoute
  ProfileCreateScenarioRoute: typeof ProfileCreateScenarioRoute
  ProfileEditRoute: typeof ProfileEditRoute
  ProfileOrdersRoute: typeof ProfileOrdersRoute
  ProfileScenariosRoute: typeof ProfileScenariosRoute
  ProfileVerifyEmailRoute: typeof ProfileVerifyEmailRoute
  ScenarioScenarioSlugRoute: typeof ScenarioScenarioSlugRoute
  TourTourIdRoute: typeof TourTourIdRoute
  UserFormConfirmationRoute: typeof UserFormConfirmationRoute
  UserFormGuestDetailsRoute: typeof UserFormGuestDetailsRoute
  UserFormSelfDetailsRoute: typeof UserFormSelfDetailsRoute
  AdminFeedbackBrokenLinkLazyRoute: typeof AdminFeedbackBrokenLinkLazyRoute
  AdminFeedbackThanksLazyRoute: typeof AdminFeedbackThanksLazyRoute
  ErrorBadRequestLazyRoute: typeof ErrorBadRequestLazyRoute
  ErrorInternalErrorLazyRoute: typeof ErrorInternalErrorLazyRoute
  FeedbackAlreadySubmittedLazyRoute: typeof FeedbackAlreadySubmittedLazyRoute
  FeedbackBrokenLinkLazyRoute: typeof FeedbackBrokenLinkLazyRoute
  FeedbackThanksLazyRoute: typeof FeedbackThanksLazyRoute
  AccommodationDetailsIndexRoute: typeof AccommodationDetailsIndexRoute
  AdminFeedbackIndexRoute: typeof AdminFeedbackIndexRoute
  AllExcursionsIndexRoute: typeof AllExcursionsIndexRoute
  AvailableAccommodationsIndexRoute: typeof AvailableAccommodationsIndexRoute
  CheckPlannerIndexRoute: typeof CheckPlannerIndexRoute
  ExcursionSelectionIndexRoute: typeof ExcursionSelectionIndexRoute
  ExcursionIndexRoute: typeof ExcursionIndexRoute
  ExternalFeedbackIndexRoute: typeof ExternalFeedbackIndexRoute
  FeedbackIndexRoute: typeof FeedbackIndexRoute
  FinalOrderIndexRoute: typeof FinalOrderIndexRoute
  OrderIndexRoute: typeof OrderIndexRoute
  PreorderIndexRoute: typeof PreorderIndexRoute
  ProfileIndexRoute: typeof ProfileIndexRoute
  TripPlannerIndexRoute: typeof TripPlannerIndexRoute
  UserFormIndexRoute: typeof UserFormIndexRoute
  DocsIndexLazyRoute: typeof DocsIndexLazyRoute
  PrivacyPolicyIndexLazyRoute: typeof PrivacyPolicyIndexLazyRoute
  TermsAndConditionsIndexLazyRoute: typeof TermsAndConditionsIndexLazyRoute
  BookingCancellationOrderNumberRoute: typeof BookingCancellationOrderNumberRoute
  BookingCancellationSuccessRoute: typeof BookingCancellationSuccessRoute
  UserFormErrorsAlreadyBookedErrorRoute: typeof UserFormErrorsAlreadyBookedErrorRoute
  BookingCancellationIndexRoute: typeof BookingCancellationIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/email-confirmation': {
      id: '/email-confirmation'
      path: '/email-confirmation'
      fullPath: '/email-confirmation'
      preLoaderRoute: typeof EmailConfirmationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entrypoint': {
      id: '/entrypoint'
      path: '/entrypoint'
      fullPath: '/entrypoint'
      preLoaderRoute: typeof EntrypointRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accommodation-details/': {
      id: '/accommodation-details/'
      path: '/accommodation-details'
      fullPath: '/accommodation-details/'
      preLoaderRoute: typeof AccommodationDetailsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin-feedback/': {
      id: '/admin-feedback/'
      path: '/admin-feedback'
      fullPath: '/admin-feedback/'
      preLoaderRoute: typeof AdminFeedbackIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin-feedback/broken-link': {
      id: '/admin-feedback/broken-link'
      path: '/admin-feedback/broken-link'
      fullPath: '/admin-feedback/broken-link'
      preLoaderRoute: typeof AdminFeedbackBrokenLinkLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin-feedback/thanks': {
      id: '/admin-feedback/thanks'
      path: '/admin-feedback/thanks'
      fullPath: '/admin-feedback/thanks'
      preLoaderRoute: typeof AdminFeedbackThanksLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/all-excursions/': {
      id: '/all-excursions/'
      path: '/all-excursions'
      fullPath: '/all-excursions/'
      preLoaderRoute: typeof AllExcursionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/': {
      id: '/auth/'
      path: '/'
      fullPath: '/auth/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/register': {
      id: '/auth/register'
      path: '/register'
      fullPath: '/auth/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/verify': {
      id: '/auth/verify'
      path: '/verify'
      fullPath: '/auth/verify'
      preLoaderRoute: typeof AuthVerifyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/vk-callback': {
      id: '/auth/vk-callback'
      path: '/vk-callback'
      fullPath: '/auth/vk-callback'
      preLoaderRoute: typeof AuthVkCallbackRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/vk-email': {
      id: '/auth/vk-email'
      path: '/vk-email'
      fullPath: '/auth/vk-email'
      preLoaderRoute: typeof AuthVkEmailRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/vk-success': {
      id: '/auth/vk-success'
      path: '/vk-success'
      fullPath: '/auth/vk-success'
      preLoaderRoute: typeof AuthVkSuccessRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/vk-verify': {
      id: '/auth/vk-verify'
      path: '/vk-verify'
      fullPath: '/auth/vk-verify'
      preLoaderRoute: typeof AuthVkVerifyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/available-accommodations/': {
      id: '/available-accommodations/'
      path: '/available-accommodations'
      fullPath: '/available-accommodations/'
      preLoaderRoute: typeof AvailableAccommodationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/check-planner/': {
      id: '/check-planner/'
      path: '/check-planner'
      fullPath: '/check-planner/'
      preLoaderRoute: typeof CheckPlannerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/': {
      id: '/docs/'
      path: '/docs'
      fullPath: '/docs/'
      preLoaderRoute: typeof DocsIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error/bad-request': {
      id: '/error/bad-request'
      path: '/error/bad-request'
      fullPath: '/error/bad-request'
      preLoaderRoute: typeof ErrorBadRequestLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error/internal-error': {
      id: '/error/internal-error'
      path: '/error/internal-error'
      fullPath: '/error/internal-error'
      preLoaderRoute: typeof ErrorInternalErrorLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error/payment-error': {
      id: '/error/payment-error'
      path: '/error/payment-error'
      fullPath: '/error/payment-error'
      preLoaderRoute: typeof ErrorPaymentErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/excursion-selection/': {
      id: '/excursion-selection/'
      path: '/excursion-selection'
      fullPath: '/excursion-selection/'
      preLoaderRoute: typeof ExcursionSelectionIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/excursion/': {
      id: '/excursion/'
      path: '/excursion'
      fullPath: '/excursion/'
      preLoaderRoute: typeof ExcursionIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/external-feedback/': {
      id: '/external-feedback/'
      path: '/external-feedback'
      fullPath: '/external-feedback/'
      preLoaderRoute: typeof ExternalFeedbackIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feedback/': {
      id: '/feedback/'
      path: '/feedback'
      fullPath: '/feedback/'
      preLoaderRoute: typeof FeedbackIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feedback/already-submitted': {
      id: '/feedback/already-submitted'
      path: '/feedback/already-submitted'
      fullPath: '/feedback/already-submitted'
      preLoaderRoute: typeof FeedbackAlreadySubmittedLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feedback/broken-link': {
      id: '/feedback/broken-link'
      path: '/feedback/broken-link'
      fullPath: '/feedback/broken-link'
      preLoaderRoute: typeof FeedbackBrokenLinkLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feedback/thanks': {
      id: '/feedback/thanks'
      path: '/feedback/thanks'
      fullPath: '/feedback/thanks'
      preLoaderRoute: typeof FeedbackThanksLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/final-order/': {
      id: '/final-order/'
      path: '/final-order'
      fullPath: '/final-order/'
      preLoaderRoute: typeof FinalOrderIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/order/': {
      id: '/order/'
      path: '/order'
      fullPath: '/order/'
      preLoaderRoute: typeof OrderIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preorder/': {
      id: '/preorder/'
      path: '/preorder'
      fullPath: '/preorder/'
      preLoaderRoute: typeof PreorderIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy/': {
      id: '/privacy-policy/'
      path: '/privacy-policy'
      fullPath: '/privacy-policy/'
      preLoaderRoute: typeof PrivacyPolicyIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/': {
      id: '/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof ProfileIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/author': {
      id: '/profile/author'
      path: '/profile/author'
      fullPath: '/profile/author'
      preLoaderRoute: typeof ProfileAuthorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/change-email': {
      id: '/profile/change-email'
      path: '/profile/change-email'
      fullPath: '/profile/change-email'
      preLoaderRoute: typeof ProfileChangeEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/create-scenario': {
      id: '/profile/create-scenario'
      path: '/profile/create-scenario'
      fullPath: '/profile/create-scenario'
      preLoaderRoute: typeof ProfileCreateScenarioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/edit': {
      id: '/profile/edit'
      path: '/profile/edit'
      fullPath: '/profile/edit'
      preLoaderRoute: typeof ProfileEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/orders': {
      id: '/profile/orders'
      path: '/profile/orders'
      fullPath: '/profile/orders'
      preLoaderRoute: typeof ProfileOrdersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/scenarios': {
      id: '/profile/scenarios'
      path: '/profile/scenarios'
      fullPath: '/profile/scenarios'
      preLoaderRoute: typeof ProfileScenariosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/verify-email': {
      id: '/profile/verify-email'
      path: '/profile/verify-email'
      fullPath: '/profile/verify-email'
      preLoaderRoute: typeof ProfileVerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scenario/$scenarioSlug': {
      id: '/scenario/$scenarioSlug'
      path: '/scenario/$scenarioSlug'
      fullPath: '/scenario/$scenarioSlug'
      preLoaderRoute: typeof ScenarioScenarioSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms-and-conditions/': {
      id: '/terms-and-conditions/'
      path: '/terms-and-conditions'
      fullPath: '/terms-and-conditions/'
      preLoaderRoute: typeof TermsAndConditionsIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tour/$tourId': {
      id: '/tour/$tourId'
      path: '/tour/$tourId'
      fullPath: '/tour/$tourId'
      preLoaderRoute: typeof TourTourIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trip-planner/': {
      id: '/trip-planner/'
      path: '/trip-planner'
      fullPath: '/trip-planner/'
      preLoaderRoute: typeof TripPlannerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user-form/': {
      id: '/user-form/'
      path: '/user-form'
      fullPath: '/user-form/'
      preLoaderRoute: typeof UserFormIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user-form/confirmation': {
      id: '/user-form/confirmation'
      path: '/user-form/confirmation'
      fullPath: '/user-form/confirmation'
      preLoaderRoute: typeof UserFormConfirmationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user-form/guest-details': {
      id: '/user-form/guest-details'
      path: '/user-form/guest-details'
      fullPath: '/user-form/guest-details'
      preLoaderRoute: typeof UserFormGuestDetailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user-form/self-details': {
      id: '/user-form/self-details'
      path: '/user-form/self-details'
      fullPath: '/user-form/self-details'
      preLoaderRoute: typeof UserFormSelfDetailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/booking/cancellation/': {
      id: '/booking/cancellation/'
      path: '/booking/cancellation'
      fullPath: '/booking/cancellation/'
      preLoaderRoute: typeof BookingCancellationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/booking/cancellation/$orderNumber': {
      id: '/booking/cancellation/$orderNumber'
      path: '/booking/cancellation/$orderNumber'
      fullPath: '/booking/cancellation/$orderNumber'
      preLoaderRoute: typeof BookingCancellationOrderNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/booking/cancellation/success': {
      id: '/booking/cancellation/success'
      path: '/booking/cancellation/success'
      fullPath: '/booking/cancellation/success'
      preLoaderRoute: typeof BookingCancellationSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user-form/errors/already-booked-error': {
      id: '/user-form/errors/already-booked-error'
      path: '/user-form/errors/already-booked-error'
      fullPath: '/user-form/errors/already-booked-error'
      preLoaderRoute: typeof UserFormErrorsAlreadyBookedErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AuthRouteChildren {
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthVerifyRoute: typeof AuthVerifyRoute
  AuthVkCallbackRoute: typeof AuthVkCallbackRoute
  AuthVkEmailRoute: typeof AuthVkEmailRoute
  AuthVkSuccessRoute: typeof AuthVkSuccessRoute
  AuthVkVerifyRoute: typeof AuthVkVerifyRoute
  AuthIndexRoute: typeof AuthIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthRegisterRoute: AuthRegisterRoute,
  AuthVerifyRoute: AuthVerifyRoute,
  AuthVkCallbackRoute: AuthVkCallbackRoute,
  AuthVkEmailRoute: AuthVkEmailRoute,
  AuthVkSuccessRoute: AuthVkSuccessRoute,
  AuthVkVerifyRoute: AuthVkVerifyRoute,
  AuthIndexRoute: AuthIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  EmailConfirmationRoute: EmailConfirmationRoute,
  EntrypointRoute: EntrypointRoute,
  ErrorPaymentErrorRoute: ErrorPaymentErrorRoute,
  ProfileAuthorRoute: ProfileAuthorRoute,
  ProfileChangeEmailRoute: ProfileChangeEmailRoute,
  ProfileCreateScenarioRoute: ProfileCreateScenarioRoute,
  ProfileEditRoute: ProfileEditRoute,
  ProfileOrdersRoute: ProfileOrdersRoute,
  ProfileScenariosRoute: ProfileScenariosRoute,
  ProfileVerifyEmailRoute: ProfileVerifyEmailRoute,
  ScenarioScenarioSlugRoute: ScenarioScenarioSlugRoute,
  TourTourIdRoute: TourTourIdRoute,
  UserFormConfirmationRoute: UserFormConfirmationRoute,
  UserFormGuestDetailsRoute: UserFormGuestDetailsRoute,
  UserFormSelfDetailsRoute: UserFormSelfDetailsRoute,
  AdminFeedbackBrokenLinkLazyRoute: AdminFeedbackBrokenLinkLazyRoute,
  AdminFeedbackThanksLazyRoute: AdminFeedbackThanksLazyRoute,
  ErrorBadRequestLazyRoute: ErrorBadRequestLazyRoute,
  ErrorInternalErrorLazyRoute: ErrorInternalErrorLazyRoute,
  FeedbackAlreadySubmittedLazyRoute: FeedbackAlreadySubmittedLazyRoute,
  FeedbackBrokenLinkLazyRoute: FeedbackBrokenLinkLazyRoute,
  FeedbackThanksLazyRoute: FeedbackThanksLazyRoute,
  AccommodationDetailsIndexRoute: AccommodationDetailsIndexRoute,
  AdminFeedbackIndexRoute: AdminFeedbackIndexRoute,
  AllExcursionsIndexRoute: AllExcursionsIndexRoute,
  AvailableAccommodationsIndexRoute: AvailableAccommodationsIndexRoute,
  CheckPlannerIndexRoute: CheckPlannerIndexRoute,
  ExcursionSelectionIndexRoute: ExcursionSelectionIndexRoute,
  ExcursionIndexRoute: ExcursionIndexRoute,
  ExternalFeedbackIndexRoute: ExternalFeedbackIndexRoute,
  FeedbackIndexRoute: FeedbackIndexRoute,
  FinalOrderIndexRoute: FinalOrderIndexRoute,
  OrderIndexRoute: OrderIndexRoute,
  PreorderIndexRoute: PreorderIndexRoute,
  ProfileIndexRoute: ProfileIndexRoute,
  TripPlannerIndexRoute: TripPlannerIndexRoute,
  UserFormIndexRoute: UserFormIndexRoute,
  DocsIndexLazyRoute: DocsIndexLazyRoute,
  PrivacyPolicyIndexLazyRoute: PrivacyPolicyIndexLazyRoute,
  TermsAndConditionsIndexLazyRoute: TermsAndConditionsIndexLazyRoute,
  BookingCancellationOrderNumberRoute: BookingCancellationOrderNumberRoute,
  BookingCancellationSuccessRoute: BookingCancellationSuccessRoute,
  UserFormErrorsAlreadyBookedErrorRoute: UserFormErrorsAlreadyBookedErrorRoute,
  BookingCancellationIndexRoute: BookingCancellationIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
